import { render, staticRenderFns } from "./TabSwitcher.vue?vue&type=template&id=c1f0c9ee&scoped=true&"
import script from "./TabSwitcher.vue?vue&type=script&lang=js&"
export * from "./TabSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./TabSwitcher.vue?vue&type=style&index=0&id=c1f0c9ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f0c9ee",
  null
  
)

export default component.exports